<template>
  <div class="browsing-tags">
    <language-tag
      v-for="language in languages"
      :key="language.id"
      :language="language"
      :onClick="clickTag"
      :isSelected="selectedTags.includes(language.id)"
    />
  </div>
</template>

<script>
import LanguageTag from "./LanguageTag.vue";
import { mapState } from "vuex";

export default {
  components: { LanguageTag },
  name: "LanguageTags",
  props: ["onChangeLanguageTags"],
  data: function () {
    return {
      selectedTags: [],
      selectedLanguages: [],
    };
  },
  async created() {},
  computed: {
    ...mapState({
      languages: "languages",
    }),
  },
  methods: {
    clickTag(key) {
      if (this.selectedTags.includes(key)) {
        this.selectedTags.splice(this.selectedTags.indexOf(key), 1);
      } else {
        this.selectedTags.push(key);
      }
      this.onChangeLanguageTags(this.selectedTags);
    },
  },
};
</script>

<style lang="scss" scoped>
.browsing-tags {
  display: flex;
  flex-wrap: wrap;
  margin-left: 25px;
  max-width: 940px;
  padding-top: 20px;
}

@media (max-width: 1024px) {
  .browsing-tags {
    margin-left: 5px;
  }
}
</style>
